/**
 * @deprecated Import from 'src/integrations/react-router/utils.js' instead.
 */
export {
  ReactRouterMode,
  getReactRouterVersionBucket,
  getReactRouterMode,
  getReactRouterModeName,
} from '../integrations/react-router/utils.js';
